var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:w-[16%] sm:w-[50%] sm:max-w-[50%] md:max-w-[16%] csat--metric-card",class:{
    disabled: _vm.disabled,
  }},[_c('h3',{staticClass:"heading"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('fluent-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.infoText),expression:"infoText"}],staticClass:"csat--icon",attrs:{"size":"14","icon":"info"}})],1),_vm._v(" "),_c('h4',{staticClass:"metric"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }